module.exports = __webpack_public_path__ + "img/3 AOGS LOGO-01.cd668b8d.png";